/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc
 */

/**
 *  Describes a block <em>type</em> that is registered in code (for example {@code HEADER}). It is the
 *  schema the frontend uses to render an editor palette and per-field form controls, and the contract
 *  a placed {@link LayoutBlockIF} of this type is validated against.
 */

/**
 *  A single field value on a placed {@link LayoutBlockIF}. Values are stored in typed slots keyed by
 *  {@link #getType()} - only the slot matching the type is populated, which keeps the wire schema
 *  flat (no union) while still preserving the field's type for the frontend.
 */

/**
 *  Requests a public (no-auth) share token for the Breeze artifact the editor just selected for a
 *  {@code BREEZE_ARTIFACT} block. {@code artifactId} is the Breeze artifact id (a {@code long}) to
 *  mint a link for.
 */

/**
 *  The minted public share link for a Breeze artifact. {@code accessToken} is stored on the
 *  {@code BREEZE_ARTIFACT} block and later resolved with no auth by portal buyers via
 *  {@code BreezeAssistantPublicArtifactsRpc#resolvePublicShareLink}; {@code expireAt} is the link's
 *  expiry (epoch millis) as returned by Breeze.
 */

/**
 * Result of a delete/discard: whether anything was removed, plus the instance's remaining layouts.
 */

/**
 * Result of a template delete: whether anything was removed, plus the instance's remaining templates.
 */

/**
 *  One selectable Breeze artifact for the layout editor's embed field selector. {@code artifactId} is
 *  the Breeze artifact id (a {@code long}) that a {@code BREEZE_ARTIFACT} block points at; {@code title}
 *  and {@code artifactType} are for display in the selector.
 */

/**
 *  Declares one editable field belonging to a {@link BlockDefinitionIF} - its name, display label,
 *  data type, whether it must be supplied, and an optional default value used when a block is first
 *  added.
 */

/**
 * One full template (all of its blocks) for a portal instance.
 */

/**
 *  A block placed within a {@link PortalLayoutIF}. {@link #getBlockType()} references a registered
 *  {@link BlockDefinitionIF#getType()}. Layout is intentionally simple: a single column of full-width
 *  blocks stacked top to bottom in list order. The same block type may appear any number of times.
 */

/**
 *  The single business error for the layout service. {@link LayoutErrorReason#VALIDATION_FAILED} is
 *  thrown when a submitted layout fails validation against the registered block definitions;
 *  {@link LayoutErrorReason#ACCESS_DENIED} is thrown when the caller is not permitted to edit (for
 *  example, not a HubSpot user). Framework-level authentication failures surface separately as
 *  {@code PortalAuthError} from the {@code @PortalAuth} interceptor.
 */

/**
 *  A lightweight descriptor of a saved layout, used to render a picker of the layouts belonging to a
 *  portal instance without shipping every block.
 */

/**
 *  A reusable, named set of {@link LayoutBlockIF}s that layouts can be created from. Unlike a {@link
 *  PortalLayoutIF}, a template has no draft/published lifecycle - it is a starting point. It is
 *  identified within its portal instance by {@link #getTemplateKey()} (which, unlike a layout key, has
 *  no default - a template is always named) and shown to people by {@link #getLabel()}. Built-in
 *  starter templates share this shape with sentinel {@code portalId}/{@code portalInstanceId} of
 *  {@code 0}, since they belong to no instance.
 */

/**
 *  A lightweight descriptor of a layout template, used to render a picker of the templates available
 *  to a portal instance (its own saved templates plus the built-in starters) without shipping every
 *  block.
 */

/**
 *  Lists every layout saved for the portal instance identified by the request's
 *  {@code portalInstanceId} (and {@code accountId}).
 */

/**
 * Lists the templates available to the portal instance (its saved templates plus built-in starters).
 */

/**
 * The templates available to a portal instance: its saved templates plus the built-in starters.
 */

/**
 *  A saved layout belonging to a single portal instance: an ordered list of {@link LayoutBlockIF}s. A
 *  layout is identified within its instance by {@link #getLayoutKey()} (defaulting to
 *  {@code "default"}), so one {@code (portalId, portalInstanceId)} may own several distinct layouts,
 *  each with its own human-readable {@link #getLabel()}.
 */

/**
 * Promotes the current draft of a layout to the published (live) copy.
 */

/**
 *  Rearranges the layouts of the portal instance identified by the request's {@code portalInstanceId}
 *  (and {@code accountId}). The layouts are repositioned to match {@link #getLayoutKeys()} order (the
 *  first key sorts to the top); any existing layout omitted from the list keeps its current relative
 *  position after the ones listed.
 */

/**
 * The saved template, returned by both saveTemplate and saveLayoutAsTemplate.
 */

export const listBlockDefinitionsRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'listBlockDefinitions',
  auth: 'external',
  fingerprint: 'raEyd0UvXTArqYwO7eT22JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listEmbeddableBreezeArtifactsRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'listEmbeddableBreezeArtifacts',
  auth: 'external',
  fingerprint: 'ND9QwV7Glp1qI_F-MV54-tv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createBreezeArtifactShareLinkRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'createBreezeArtifactShareLink',
  auth: 'external',
  fingerprint: 'NYC9MK2cWYaxawVBjXv_HNv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listLayoutsRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'listLayouts',
  auth: 'external',
  fingerprint: 'aAkE1g2xD1LEniOJqwu_Kdv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const reorderLayoutsRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'reorderLayouts',
  auth: 'external',
  fingerprint: 'R36rN97QqvDEniOJqwu_Kdv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLayoutRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'getLayout',
  auth: 'external',
  fingerprint: '3dmQ0UZcHPxx784eULWu1Nv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveDraftRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'saveDraft',
  auth: 'external',
  fingerprint: 'k7daeAUHa9gDi9ZLNyCprdv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const publishRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'publish',
  auth: 'external',
  fingerprint: 'dIFp2Tz99oEDi9ZLNyCprdv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveLayoutRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'saveLayout',
  auth: 'external',
  fingerprint: 'k7daeAUHa9gDi9ZLNyCprdv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteLayoutRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'deleteLayout',
  auth: 'external',
  fingerprint: 'yNJJcaVYZySx7NhCa1C4Gdv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listTemplatesRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'listTemplates',
  auth: 'external',
  fingerprint: '9pvT7OQY4wqxvBpruS_B6tv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTemplateRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'getTemplate',
  auth: 'external',
  fingerprint: 'tLXU0Ta1Kc1gMxHCIYAOqNv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveTemplateRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'saveTemplate',
  auth: 'external',
  fingerprint: 'mdH0FP6pgUV4OwIe7zzOZ9v3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteTemplateRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'deleteTemplate',
  auth: 'external',
  fingerprint: '1FAcEyM0QEkT0bb3K6TfgNv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createLayoutFromTemplateRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'createLayoutFromTemplate',
  auth: 'external',
  fingerprint: 'HlYob6w2fToDi9ZLNyCprdv3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const saveLayoutAsTemplateRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalLayoutRpc',
  rpcName: 'saveLayoutAsTemplate',
  auth: 'external',
  fingerprint: 'Tni_ZCAgPqN4OwIe7zzOZ9v3glj1WAZI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};